import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/bigger-rear-fan.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/front-fan.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/parts.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/rear-fan.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/sliding-rail-1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/sliding-rail-2.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2020/new-computer/ups.jpg");
